import React from "react";
import { LabelWrapperStyled, LabelStyled } from "./styles/Styled";

export default ({ stickyLabelName }) => {
  return (
    <LabelWrapperStyled>
      <LabelStyled>{stickyLabelName}</LabelStyled>
    </LabelWrapperStyled>
  );
};
